import moment from 'moment';
import { NButton } from 'naive-ui';
import * as Sentry from "@sentry/browser";
import { App, h } from 'vue';
import i18n from '~/i18n';

export default {
    install: (app: App) => {
        app.config.errorHandler = (err, vm, info) => {
            console.error(err, vm, info);
            //@ts-ignore
            if(window.$notifications) {
                const n = window.$notifications.create({
                    title: i18n.global.t('error.global_error_title'),
                    content: i18n.global.t('error.global_error.content'),
                    meta: moment().format('LLL'),
                    type: 'error',
                    action: () => h(
                        NButton,
                        {
                          text: true,
                          type: 'primary',
                          onClick: () => {
                            let eventId = null;
                            if(err && err instanceof Error) {
                                Sentry.withScope((scope: Sentry.Scope) => {
                                    scope.setExtra('vm', vm);
                                    scope.setExtra('info', info);
                                    eventId = Sentry.captureException(err);
                                });
                            } else {
                                Sentry.withScope((scope: Sentry.Scope) => {
                                    Object.entries(err)
                                        .filter((entry: [string, unknown]) => ['string', 'number', 'object'].includes(typeof entry[1]))
                                        .forEach(([key, value]: [string, string | number]) => scope.setExtra(key, value));
                                    eventId = Sentry.captureMessage(`Global failure`);
                                })
                            }

                            if(eventId) {
                                window.$notifications.success({
                                    content: i18n.global.t('error.bug_report_sent'),
                                })
                            } else {
                                window.$notifications.error({
                                    content: i18n.global.t('error.bug_report_not_sent'),
                                })
                            }

                            n.destroy();
                          }
                        },
                        {
                          default: () => i18n.global.t('error.global_error_report'),
                        }
                      ),
                });
            }
        }
    } 
};